// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import InteractiveMapTab from '../../../components/InteractiveMap/InteractiveMapTab';

// You can define here the tab components mapping for the custom parameters group of your solution
export const CUSTOM_PARAMETERS_GROUPS_COMPONENTS_MAPPING = {
  // parametersGroupId: CustomScenarioParametersTabComponent,
  interactiveMap: InteractiveMapTab,
};
